import axios from 'axios';
import authHeader from '../_helpers/auth-header';

const API_URL = process.env.VUE_APP_API_URL;

class BeritaService {
  get(params) {
    return axios.get(API_URL + 'berita?' + params, { headers: authHeader() });
  }

  add(data) {
    return axios.post(API_URL + 'berita', data, { headers: authHeader() });
  }

  update(id, data) {
    return axios.post(API_URL + 'berita-update/' + id, data, { headers: authHeader() });
  }

  detail(id) {
    return axios.get(API_URL + 'berita/' + id, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + 'berita/' + id, { headers: authHeader() });
  }
}

export default new BeritaService();